import React from "react";
import { useUserAuth } from "../../../contexts/UserAuthContext";
import { useToast } from "../../../contexts/ToastContext";
import { useMatchesQuery, useDeleteMatchMutation } from "../../../hooks/profile/queries";
import MatchesView from "../../../components/profile/views/MatchesView";

/**
 * MatchesPage - User's product match sessions
 */
const MatchesPage = () => {
  const { user } = useUserAuth();
  const { showToast } = useToast();
  const userId = user?.id || user?._id;

  const { data: matchSessions = [], isLoading, error, refetch } = useMatchesQuery(userId);
  const deleteMutation = useDeleteMatchMutation();

  const handleRefresh = () => {
    refetch();
    // Refresh indicator in UI is sufficient feedback
  };

  const handleDelete = async (matchIdOrIds) => {
    const ids = (Array.isArray(matchIdOrIds) ? matchIdOrIds : [matchIdOrIds]).filter(
      Boolean,
    );
    if (ids.length === 0) return;

    try {
      const result = await deleteMutation.mutateAsync(
        ids.length === 1 ? ids[0] : ids,
      );
      const removed = Number.isFinite(result?.deletedCount)
        ? result.deletedCount
        : ids.length;
      showToast({
        message:
          removed === 1
            ? "Match removed"
            : `${removed} matches removed`,
        type: "success",
      });
    } catch (err) {
      showToast({
        message:
          err.response?.data?.message ||
          (ids.length === 1 ? "Failed to remove match" : "Failed to remove matches"),
        type: "error",
      });
      throw err;
    }
  };

  return (
    <MatchesView
      matchSessions={matchSessions}
      loading={isLoading}
      error={error?.message}
      onRefresh={handleRefresh}
      onDelete={handleDelete}
      showToast={showToast}
      currentTab="matches"
    />
  );
};

export default MatchesPage;
